import { httpApi } from '@app/api/http.api'

export interface AuditLogEntry {
  id: string
  createdAt: string
  operationType: string
  operationResult: 'SUCCESS' | 'ERROR'
  actorType: string
  userEmail: string | null
  ipAddress: string | null
  resourceType: string | null
  resourceId: string | null
  errorCode: string | null
  errorMessage: string | null
  source: string
  recipient: string | null
}

export interface AuditLogPage {
  data: AuditLogEntry[]
  total: number
  page: number
  limit: number
}

export interface AuditLogFilters {
  page?: number
  limit?: number
  operationType?: string
  operationTypes?: string[]
  operationResult?: string
  operationResults?: string[]
  userEmail?: string
  dateFrom?: string
  dateTo?: string
}

export const getAuditLog = (filters: AuditLogFilters = {}): Promise<AuditLogPage> => {
  const params = new URLSearchParams()
  const { operationTypes, operationResults, ...rest } = filters
  Object.entries(rest).forEach(([key, val]) => {
    if (val !== undefined && val !== '') params.append(key, String(val))
  })
  if (operationTypes?.length) {
    operationTypes.forEach((type) => params.append('operationTypes', type))
  }
  if (operationResults?.length) {
    operationResults.forEach((result) => params.append('operationResults', result))
  }
  const query = params.toString()
  return httpApi.get<AuditLogPage>(`audit-log${query ? `?${query}` : ''}`).then(({ data }) => data)
}
